// src/axiosInstance.js
import axios from "axios";
import Cookies from "js-cookie";
import { clearTokens } from "./Services/auth";

const axiosAuthInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_AUTH || "", // Default endpoint
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

// Note: Refresh flow removed; we now logout on expiration

// Centralized handler for session expiration: clears auth, local state and navigates to login
const handleSessionExpired = () => {
  try {
    clearTokens?.();
  } catch (_) {}
  try {
    Cookies.remove("idtoken");
    Cookies.remove("refreshtoken");
    Cookies.remove("Device_id");
  } catch (_) {}
  try {
    // Clear app local storage (safe reset)
    localStorage.clear();
  } catch (_) {}

  const currentFullPath = (() => {
    try {
      const path = window.location?.pathname || "/";
      const search = window.location?.search || "";
      // Avoid redirect loop if already on /login
      if (path === "/login") return "/dashboard"; // send to a safe default after login
      return `${path}${search}`;
    } catch (_) {
      return "/dashboard";
    }
  })();

  const params = new URLSearchParams();
  params.set("session_msg", "Session expired, please login again");
  if (currentFullPath) params.set("redirect_uri", currentFullPath);
  window.location.href = `/login?${params.toString()}`;
};

// Response Interceptor for axiosRelationshipInstance
axiosAuthInstance.interceptors.request // Add a request interceptor to inject the Access Token into the Authorization header
  .use(
    (config) => {
      const accessToken = Cookies.get("idtoken");
      if (accessToken) {
        config.headers["Authorization"] = `Bearer ${accessToken}`;
        config.headers["Device_id"] = Cookies.get("Device_id");
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

axiosAuthInstance.interceptors.response.use(
  async (response) => {
    return response;
  },
  async (error) => {
    if (error?.status === 498 || error?.response?.status === 498) {
      handleSessionExpired();
      return Promise.reject(error);
    }
    const { config } = error;
    if (error?.response?.status === 401) {
      handleSessionExpired();
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

const axiosLoginInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_AUTH || "", // Default endpoint
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

const axiosAssessmentInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_ASSESSMENT || "", // Default endpoint
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

// Add interceptors for request or response if needed
axiosAssessmentInstance.interceptors.request // Add a request interceptor to inject the Access Token into the Authorization header
  .use(
    (config) => {
      const accessToken = Cookies.get("idtoken");
      if (accessToken) {
        config.headers["Authorization"] = `Bearer ${accessToken}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

axiosAssessmentInstance.interceptors.response.use(
  async (response) => {
    return response;
  },
  async (error) => {
    const { config } = error;
    if (error?.status === 498 || error?.response?.status === 498) {
      handleSessionExpired();
      return Promise.reject(error);
    }
    if (error.response?.status === 401) {
      handleSessionExpired();
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

//subscription Assessment
const axiosSubstanceInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_SUBSCRIPTION || "", // Default endpoint
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

// Add interceptors for request or response if needed
axiosSubstanceInstance.interceptors.request // Add a request interceptor to inject the Access Token into the Authorization header
  .use(
    (config) => {
      const accessToken = Cookies.get("idtoken");
      if (accessToken) {
        config.headers["Authorization"] = `Bearer ${accessToken}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

axiosSubstanceInstance.interceptors.response.use(
  async (response) => {
    return response;
  },
  async (error) => {
    const { config } = error;
    if (error?.status === 498 || error?.response?.status === 498) {
      handleSessionExpired();
      return Promise.reject(error);
    }
    if (error.response?.status === 401) {
      handleSessionExpired();
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

const axiosArisChatInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_CHAT_ARIS || "", // Default endpoint
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

axiosArisChatInstance.interceptors.request // Add a request interceptor to inject the Access Token into the Authorization header

  .use(
    (config) => {
      const accessToken = Cookies.get("idtoken");
      if (!accessToken) {
        const path = window.location?.pathname || "/";
        const search = window.location?.search || "";
        const redirect = encodeURIComponent(`${path}${search}`);
        window.location.href = `/login?redirect_uri=${redirect}`;
        return Promise.reject("No access token found");
      }

      config.headers["Authorization"] = `Bearer ${accessToken}`;
      config.headers["Device_id"] = Cookies.get("Device_id");
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

const axiosChatInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_ASSESSMENT || "", // Default endpoint
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});
axiosChatInstance.interceptors.request // Add a request interceptor to inject the Access Token into the Authorization header

  .use(
    (config) => {
      const accessToken = Cookies.get("idtoken");
      if (!accessToken) {
        const path = window.location?.pathname || "/";
        const search = window.location?.search || "";
        const redirect = encodeURIComponent(`${path}${search}`);
        window.location.href = `/login?redirect_uri=${redirect}`;
        return Promise.reject("No access token found");
      }

      config.headers["Authorization"] = `Bearer ${accessToken}`;
      config.headers["Device_id"] = Cookies.get("Device_id");
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

axiosChatInstance.interceptors.response.use(
  async (response) => {
    return response;
  },
  async (error) => {
    const { config } = error;
    if (error?.status === 498 || error?.response?.status === 498) {
      handleSessionExpired();
      return Promise.reject(error);
    }
    if (error.response?.status === 401) {
      handleSessionExpired();
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

const axiosRelationshipInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_ASSESSMENT || "", // Default endpoint
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

axiosRelationshipInstance.interceptors.request // Add a request interceptor to inject the Access Token into the Authorization header
  .use(
    (config) => {
      const accessToken = Cookies.get("idtoken");
      if (!accessToken) {
        const path = window.location?.pathname || "/";
        const search = window.location?.search || "";
        const redirect = encodeURIComponent(`${path}${search}`);
        window.location.href = `/login?redirect_uri=${redirect}`;
        return Promise.reject("No access token found");
      }

      config.headers["Authorization"] = `Bearer ${accessToken}`;
      config.headers["Device_id"] = Cookies.get("Device_id");
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

axiosRelationshipInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config } = error;
    if (error?.status === 498 || error?.response?.status === 498) {
      handleSessionExpired();
      return Promise.reject(error);
    }
    if (error.response?.status === 401) {
      handleSessionExpired();
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

const axiosProfileInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_ASSESSMENT || "", // Default endpoint
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

axiosProfileInstance.interceptors.request // Add a request interceptor to inject the Access Token into the Authorization header
  .use(
    (config) => {
      const accessToken = Cookies.get("idtoken");
      if (accessToken) {
        config.headers["Authorization"] = `Bearer ${accessToken}`;
        config.headers["Device_id"] = Cookies.get("Device_id");
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

axiosProfileInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config } = error;
    if (error?.status === 498 || error?.response?.status === 498) {
      handleSessionExpired();
      return Promise.reject(error);
    }
    if (error.response?.status === 401) {
      handleSessionExpired();
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

// Optional: Add a response interceptor for axiosArisChatInstance to handle 401/498 similarly
axiosArisChatInstance.interceptors.response?.use(
  (response) => response,
  async (error) => {
    if (error?.status === 498 || error?.response?.status === 498) {
      handleSessionExpired();
      return Promise.reject(error);
    }
    if (error?.response?.status === 401) {
      handleSessionExpired();
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export {
  axiosAuthInstance,
  axiosAssessmentInstance,
  axiosArisChatInstance,
  axiosChatInstance,
  axiosRelationshipInstance,
  axiosProfileInstance,
  axiosLoginInstance,
  axiosSubstanceInstance,
};
